import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentSelectedPartyInvolvedDto extends EpimsBaseEntityDto {
    
    EventTypeId: string;
    PartyInvolvedId: string;
    PartyInvolvedName: string;  
   
    
    IncidentTrackingNo: string;
    

}